import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  header: {
    id: 'BasicEventForm.header',
    defaultMessage: 'Event Details',
  },
  subheader: {
    id: 'BasicEventForm.subheader',
    defaultMessage:
      "Let's get gather some basic information about your event so we can get started.",
  },
  eventNameLabel: {
    id: 'BasicEventForm.eventNameLabel',
    defaultMessage: 'What do you want to name your event?',
  },
  eventName: {
    id: 'BasicEventForm.eventName',
    defaultMessage: 'Event name',
  },
  eventDateLabel: {
    id: 'BasicEventForm.eventDateLabel',
    defaultMessage: 'When is your event taking place?',
  },
  eventDate: {
    id: 'BasicEventForm.eventDate',
    defaultMessage: 'The event date',
  },
  errorLabel: {
    id: 'BasicEventForm.errorLabel',
    defaultMessage: '{field} is required',
  },
  dateError: {
    id: 'BasicEventForm.dateError',
    defaultMessage: 'The date cannot be in the past',
  },
  otherCategoryLabel: {
    id: 'BasicEventForm.otherCategoryLabel',
    defaultMessage: 'Other event type?',
  },
  otherCategory: {
    id: 'BasicEventForm.otherCategory',
    defaultMessage: 'Other',
  },
  nextButton: {
    id: 'BasicEventForm.nextButton',
    defaultMessage: 'Submit',
  },
})
